import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { getPathLanguage, getLanguage } from 'utils/params';
import { ArrowRightCircle } from 'layouts/commons/icons';

const AboutIsnContent = props => {
  const pathLanguage = getPathLanguage(useLocation());
  const language = getLanguage(useLocation());
  const { data } = props || {};
  const linkList = [
    `${pathLanguage}/about-us/company-profile`,
    `${pathLanguage}/about-us/group-companies`,
    `${pathLanguage}/about-us/housing-material/overview`,
    `${pathLanguage}/about-us/contact-us`,
  ];
  // console.log(props)
  const menuItems =
    data &&
    data?.map((el, index) => {
      return {
        ...el,
        linkTo: linkList[index],
      };
    });
  return (
    <div className="overview-company">
      <div className="container-fluid">
        <div className="row">
          {menuItems &&
            menuItems.map((el, index) => {
              return (
                <div className="col-12 col-md-6 pl-0 pr-0" key={`aboutus${index}`}>
                  <div className="overview-company-image">
                    <Link className="h-100 w-100 company-image-link" to={el.linkTo}>
                      <img
                        alt="post 1"
                        src={`${process.env.REACT_APP_ISN_IMAGE_URL}${el.imageUrl}`}
                        className="w-100 h-100"
                      />
                      <div className="overview-company-overlay w-100 h-100" />
                      <div className={`overview-company-title ${language === 'jp' ? 'font-noto-serif-cjk-jp' : ''}`}>
                        <div className="title-name">{el.name}</div>
                        <div className="see-more">
                          <ArrowRightCircle />
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AboutIsnContent);
